<script setup lang="ts">
    import WasteCenterType from '@/app/worksite/enums/WasteCenterType';
    import { FormInputProps, FormInputData } from '~~/composables/useFormInput';

    const selectablesTypes = useSelectableEnum(WasteCenterType, 'enum.waste_center_type.key');

    const props = defineProps<FormInputProps>();
    const inputData: FormInputData = useFormInput(props);
</script>

<template>
    <FormElement :input-data="inputData">
        <select
            :id="inputData.inputId.value"
            v-model="inputData.model.value"
            :class="`${inputData.className.value} cursor-pointer`"
            :name="inputData.props.inputName"
        >
            <slot>
                <option
                    v-if="withNullOption"
                    value=""
                >
                    {{ $t('misc.select_placeholder') }}
                </option>
                <option
                    v-for="type in selectablesTypes"
                    :key="type.id"
                    :value="type.value"
                >
                    {{ $t(type.label) }}
                </option>
            </slot>
        </select>
    </FormElement>
</template>
